import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function EditFilledIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 25 25" htmlColor={Color.PrimaryMain} {...props}>
      <path d="M4.83 21.225a.88.88 0 0 1-.644-.26.87.87 0 0 1-.26-.644V18.59a1.8 1.8 0 0 1 .527-1.275L17.117 4.656a1.7 1.7 0 0 1 .5-.318 1.5 1.5 0 0 1 .575-.113q.3 0 .583.107.282.106.5.34l1.22 1.236q.233.217.332.5c.099.283.1.377.1.566q0 .301-.104.575-.103.274-.328.501L7.838 20.698a1.8 1.8 0 0 1-1.275.527zM17.978 8.42l1.448-1.438-1.255-1.256-1.439 1.448z" />
    </MuiSvgIcon>
  );
}
export default EditFilledIcon;
